import React from "react";
import { Link } from "react-router-dom";
import "./style/button.css";

function AboutButton() {
	return (
		<Link to="/about" style={{ display: "flow", textAlign: "center" }}>
			<button className="button">ABOUT</button>
		</Link>
	);
}

export default AboutButton;
